import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'
import GhostContentAPI from '@tryghost/content-api';
import { Container } from "reactstrap";

const Ghost = () => {
  
  const { postId } = useParams();
  const [post, setPost] = useState();
  const [createdAt, setCreatedAt] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const api = new GhostContentAPI({
      url: 'https://www.blog.drtrust360.com',
      key: '720b12fc0c88d60a4d926d4596',
      version: "v3"
    });
    
    api.posts
        .read({id: postId}, {formats: ['html', 'plaintext']})
        .then((posts) => {
          if(posts && posts.title && posts.feature_image && posts.html) {
            setPost(posts);
            let created  = new Date(posts.created_at);
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            setCreatedAt(`${monthNames[created.getMonth()]} ${created.getDate()} ${created.getFullYear()}`)
            setLoading(false);
          }
        })
        .catch((err) => {
            console.error(err);
            setLoading(false);
        });
  }, []);

  return (
    <>
      {/* {post && createdAt && */}
        <Container className="ghost-container">
          <header className="single-header">
            <div className="single-meta">
              <span>{loading ? <Skeleton width={70} height={10} inline /> : createdAt} <span className="ms-1 me-1">•</span> {loading ? <Skeleton width={70} height={10} inline /> : `${post.reading_time} Min Read`}</span>
            </div>
            <h1 className="single-title">
              {loading ? <Skeleton count={3} /> : post.title}
            </h1>
            {loading ? <Skeleton height={110} /> : <img className="ghost-feature-img" src={post.feature_image.replace('http://','https://')} />}
          </header>
          <div className="single-content">
              {loading ?
                <>
                  <Skeleton count={6}/><br />
                  <Skeleton count={8}/><br />
                  <Skeleton count={3}/><br />
                  <Skeleton count={20}/>
                </> : 
                <div dangerouslySetInnerHTML={{__html: post.html}} />
              }
          </div>
        </Container>
      {/* } */}
    </>
  );

};

export default Ghost